/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Container,
  Button,
  Row,
  Col,
  Label,
  Card,
  CardTitle,
  Dropdown,
  CardText,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import { FiShare2, FiBriefcase } from "react-icons/fi";
import { TiLocation } from "react-icons/ti";
import { FaArrowLeft, FaArrowRight, FaShareAlt } from "react-icons/fa";
import { MdCall } from "react-icons/md";

import {
  BiExitFullscreen,
  BiDotsVerticalRounded,
  BiPlus,
} from "react-icons/bi";
import ShareModal from "../../../../components/Modals/ShareModal";
import ReportSuggestionModal from "../../../../components/Modals/ReportSuggestionModal";
import CreateNewRouteModal from "../../../../components/Modals/CreateNewRouteModal";
import SelectRouteModal from "../../../../components/Modals/SelectRouteModal";
import PointsListingModal from "../../../../components/Modals/PointsListingModal";
import {
  placeDetail,
  tzadikimDetail,
} from "../../../../services/category.service";
import {
  addUserFavorite,
  removeUserFavorite,
} from "../../../../services/favourites.service";
import "./Detail.scss";
import { MdLocationOn } from "react-icons/md";
import { useSelector } from "react-redux";
import swal from "sweetalert";
import { toast } from "react-toastify";
import {
  routeDetail,
  updateRouteDetail,
  pointList,
} from "../../../../services/myRoute.service";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../../../../utils/action/Action";
import axios from "axios";
import { API_URL } from "../../../../config/config";
import ViewImagesModal from "../../../../components/Modals/ViewImagesModal";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { IoNavigateSharp } from "react-icons/io5";
import { MdAdd } from "react-icons/md";
import { FaChevronUp } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import marked_pop from "../../../../assets/marked_pop.svg";

import { Accordion } from "@zendeskgarden/react-accordions";
import card_image from "../../../../assets/card_image.png";
import ContainerLayout from "../../../../layout/ContainerLayout";
import Footer from "../../../../layout/Footer";
import BreadcrumbSection from "./BreadcrumbSection";

const responsive = {
  0: { items: 1 },
  568: { items: 2 },
  1024: { items: 3 },
};

const options = {
  minZoom: 2,
  maxZoom: 17,
  gestureHandling: "greedy",
};

function Detail({ isUserLoggedIn }) {
  const carouselRef = useRef(null);
  const firstDivRef = useRef(null);
  const secondDivRef = useRef(null);
  const [secondDivHeight, setSecondDivHeight] = useState(0); // store height

  useEffect(() => {
    if (firstDivRef.current && secondDivRef.current) {
      // Get the current height of the second div

      const height = secondDivRef.current.offsetHeight;
      setSecondDivHeight(height); // update state
      // Set the first div height to match
      firstDivRef.current.style.height = `${height}px`;
    }
  });

  const location = useLocation();
  console.log("location", location);
  const { from = "" } = location?.state || {};
  let [categoryName, setCategoryName] = useState(
    location?.state?.categoryName || "",
  );
  const { categoryTitle, categoryIcon } = location.state || {};
  console.log("fffffffffffffffffff", from, categoryName, categoryTitle);

  const [dropdownMenuOpen, setMenuOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [showCreateRouteModal, setShowCreateRouteModal] = useState(false);
  const [showListModal, setShowListModal] = useState(false);
  const [route, setRoute] = useState(null);
  const [routeName, setRouteName] = useState(null);
  const [pointName, setPointName] = useState(null);
  const [place, setPlace] = useState([]);
  const [checkForFavorite, setCheckForFavorite] = useState(null);
  const [mkmID, setMkmId] = useState();
  const [activeMarker, setActiveMarker] = useState(null);
  const [map, setMap] = useState(/**@type window?.google?.maps?.Map*/ (null));
  const [link, setLink] = useState("");
  const [mounted, setMounted] = useState(true);
  const [showSpinner, setShowSpinner] = useState(false);
  const [tzadikimTitle, setTzadikimTitle] = React.useState([]);
  const [markers, setMarkers] = useState([]);
  const [poi, setPoi] = useState(null);
  const [tempMap, setTempMap] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);
  const [modalImageId, setModalImageId] = useState(null);
  const [isOverFlowing, setIsOverFlowing] = useState(false);
  const [openIndex, setOpenIndex] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);
  const images = place.imageIDs || [];

  let imageContainerRef = useRef(null);

  const handlePrev = () => {
    if (imageContainerRef.current && imageContainerRef.current.slidePrev) {
      imageContainerRef.current.slidePrev();
      if (currentIndex > 0) {
        setCurrentIndex((prev) => prev - 1);
      }
    }
  };

  const handleNext = () => {
    if (imageContainerRef.current && imageContainerRef.current.slideNext) {
      imageContainerRef.current.slideNext();
    }
    if (currentIndex < images.length - 1) {
      setCurrentIndex((prev) => prev + 1);
    }
  };

  const toggleSection = (idx) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  const [key, setKey] = useState(0);

  useEffect(() => {
    const checkOverflow = () => {
      const container = imageContainerRef.current;
      if (container) {
        const isContentOverflowing =
          container.scrollWidth > container.clientWidth;
        setIsOverFlowing(isContentOverflowing);
      }
    };

    checkOverflow();

    window.addEventListener("resize", checkOverflow);

    return () => {
      window.removeEventListener("resize", checkOverflow);
    };
  }, [place?.imageIDs]);

  useEffect(() => {
    fetchPointList();
    if (location?.state) {
      console.log("location changes", location.state.categoryName);
      if (location?.search?.includes("tzadikimId")) {
        setCategoryName("Tzadikim");
      } else {
        setCategoryName("Cemeteries");
      }
      console.log("category changes", categoryName);
      console.log("looooooooooooooooooooo1", markers);
    }
  }, [location]);

  useEffect(() => {
    console.log("looooooooooooooooooooo", location.state);
    if (location?.search?.includes("tzadikimId")) {
      console.log("user goooooooooooooooooooooooooes back");
      setCategoryName("Tzadikim");
      tzadikimPlaceDetail();
    } else {
      setCategoryName(categoryName);
      fetchPlaceDetails();
    }
  }, [location.state, categoryName]);

  async function fetchPointList() {
    try {
      const res = await pointList();

      if (res?.status === 200) {
        console.log("point list", res);
        setMarkers(res.data);
      }
    } catch (error) {
      console.error("Failed to fetch point list:", error);
    }
  }

  const toggle = () => {
    setShowModal(!showModal);
    setRoute(null);
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  console.log("categoryName", categoryName);

  const email = useSelector(
    (state) => state?.userDetailReducer?.userData?.email,
  );
  const userName = useSelector(
    (state) => state?.userDetailReducer?.userData?.userName,
  );

  const pattern = /[?&]([^=#]+)=([^&#]*)/g;

  const parameters = {};

  let match;
  while ((match = pattern.exec(location.search))) {
    const key = decodeURIComponent(match[1]);
    const value = decodeURIComponent(match[2]);
    parameters[key] = value;
  }

  const tzadikimId = parameters["tzadikimId"];
  const mkmId = parameters["MkmId"];

  let id = tzadikimId || mkmId;
  console.log("id", id);
  // const poi = parameters["cor"];
  console.log("poi", poi);
  if (poi) {
    var nearBy = poi?.split(",");
  }

  const exploreNearByCloseInfo = () => {
    setActiveMarker(null);
  };

  var detailPoi = poi?.split(",");

  // const center = {
  //   lat: Number(detailPoi[0]),
  //   lng: Number(detailPoi[1]),
  // };

  console.log("center", markers);

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    setPlace([]);
    setTzadikimTitle([]);
    // tzadikimPlaceDetail();
    if (mounted) {
      categoryName === undefined &&
        categoryName !== "Tzadikim" &&
        categoryName !== "" &&
        fetchPlaceDetails();
    }
    return () => {
      setMounted(false);
    };
  }, []);

  useEffect(() => {
    // categoryName === "Tzadikim" || categoryName !== undefined ? tzadikimPlaceDetail() : fetchPlaceDetails();
    if (
      categoryName === "Tzadikim" &&
      categoryName !== undefined &&
      categoryName !== ""
    )
      tzadikimPlaceDetail();
    if (
      categoryName !== "Tzadikim" &&
      categoryName !== undefined &&
      categoryName !== ""
    )
      fetchPlaceDetails();
  }, [location]);

  useEffect(() => {
    if (mounted) {
      console.log("category : ", categoryName);
      // categoryName === "Tzadikim" || categoryName !== undefined ? tzadikimPlaceDetail() : fetchPlaceDetails();
      if (
        categoryName === "Tzadikim" &&
        categoryName !== undefined &&
        categoryName !== ""
      )
        tzadikimPlaceDetail();
      if (
        categoryName !== "Tzadikim" &&
        categoryName !== undefined &&
        categoryName !== ""
      )
        fetchPlaceDetails();
    }
    return () => {
      setMounted(false);
    };
  }, [place?.cityE]);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDzh8-GocyaUY-Y1vg21IVA5M0vx6RuqI8",
  });

  const handleActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };

  const share = () => {
    setLink(window.location.href);
    setShowShareModal(true);
  };

  const fetchPlaceDetails = async () => {
    try {
      dispatch(showLoader());
      if (id) {
        let obj = {
          email: email,
          checkForFavorite: true,
        };
        let response = await placeDetail(id, obj);
        if (response && response?.status === 200) {
          setPlace(response?.data?.data);
          setPoi(response.data.data.poi);
          setTzadikimTitle(response?.data?.data.tzadikim);
          dispatch(hideLoader());
        }
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Oops.. something went wrong, try again !!!",
        {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        },
      );
      dispatch(hideLoader());
    }
  };

  const tzadikimPlaceDetail = async () => {
    try {
      // check if state.search includes tzadikimId

      dispatch(showLoader());
      let obj = {
        tzadikimID: id,
        email: email,
        checkForFavorite: true,
      };
      let response = await tzadikimDetail(obj);

      if (response && response?.status === 200) {
        setPlace(response?.data?.data);
        console.log("han be", response?.data?.data);
        console.log("Hellllllllllllllllllllo", place);

        dispatch(hideLoader());
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Oops.. something went wrong, try again !!!",
        {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        },
      );
      dispatch(hideLoader());
    }
  };
  console.log("Hellllllllllllllllllllo2", place);

  const createNewRoute = () => {
    setShowModal(false);
    setShowCreateRouteModal(true);
  };

  const addToRoute = (id, place) => {
    if (location?.state?.data) {
      if (location?.state?.data[0]?.key === "addPoints") {
        addPointInLast(id);
      } else if (location?.state?.data[0]?.key === "routeDetail") {
        addPointInLast(id);
      } else if (location?.state?.data[0]?.key === "exploreNearBy") {
        addPointInLast(id);
      } else {
        setMkmId(id);
        setShowModal(true);
      }
    } else {
      setPointName(place);
      console.log(`point name: ${pointName}`);
      setMkmId(id);
      setShowModal(true);
    }
  };
  const addPointInLast = async (id) => {
    if (isUserLoggedIn) {
      const arr = location?.state?.data[0]?.arr;
      if (arr?.length < 25) {
        let index = location?.state?.data[0]?.index;
        index = arr.length;
        let requestBody = [];
        arr?.splice(index, 0, {
          mkmID: id,
          orderNumber: 0,
          visited: false,
        });
        requestBody = arr?.map((item, i) => {
          return {
            mkmID: item?.place?.mkmID || item?.mkmID,
            orderNumber: i,
            visited: item?.visited,
          };
        });
        try {
          let res = await updateRouteDetail(requestBody, {
            userName: userName,
            routeID: location?.state?.data[0]?.route_id,
          });
          if (res && res?.status === 200) {
            toast.success("Point Added Successfully In Your Route!", {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            });
            setTimeout(() => {
              navigate(
                `/my-routes-detail/${location?.state?.data[0]?.route_id}/${location?.state?.data[0]?.route_name}`,
              );
            }, 1000);
          }
        } catch (err) {
          toast.error(
            err?.response?.data?.message ||
              "Oops.. something went wrong, try again !!!",
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            },
          );
        }
      } else {
        toast.warning(
          "Max of only 25 points can be added to a route, Kindly remove a point to add a new point.",
          {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          },
        );
      }
    } else {
      const notLoggedIn = await swal({
        title: "Please Continue to Log In",
        text: "You want to add this point in your Route?",
        icon: "warning",
        buttons: ["Cancel", "Log In"],
      });
      if (notLoggedIn) {
        navigate("/sign-in");
      }
    }
  };

  const reportSuggestion = (title, id) => {
    setMkmId(id);
    setPointName(title);
    setShowReportModal(true);
  };

  const NavigateClick = () => {
    const url = `https://www.google.com/maps/search/?api=1&query=${
      place?.poi ? place?.poi : poi
    }`;
    window.open(url, "_blank");
  };

  const NavigateToTzadikim = (a, b) => {
    const url = `/category-detail/?tzadikimId=${a}&cor=${b}`;
    // pass state to category detail page
    console.log("naaaaaaaaaaaaaaaaaaaaaavigate");
    tzadikimPlaceDetail();
    navigate(url, {
      state: {
        from: "category-detail",
        categoryName: a && "Tzadikim",
        categoryTitle: a && "צדיקים",
      },
    });
    // window.location.reload();
  };

  const navigateToCemetry = (a, b) => {
    const url = `/category-detail/?MkmId=${a}`;
    // pass state to category detail page
    navigate(url, {
      state: {
        from: "category-detail",
        categoryName: a && "Cemeteries",
        categoryTitle: a && "בית החיים",
      },
    });
    window.location.reload();
  };

  const selectRoute = async () => {
    let existingData;
    if (route?.id) {
      try {
        let response = await routeDetail({
          userName: userName,
          routeID: route?.id,
        });
        if (response && response?.status === 200) {
          existingData = response?.data?.data;
        }

        let requestBody = [];
        if (existingData?.length < 25) {
          if (existingData?.length === 0) {
            requestBody?.push({
              mkmID: mkmID,
              orderNumber: 0,
              visited: false,
            });
          } else if (existingData?.length === 1) {
            requestBody?.push({
              mkmID: existingData[0]?.place?.mkmID,
              orderNumber: 0,
              visited: false,
            });
            requestBody?.push({
              mkmID: mkmID,
              orderNumber: 1,
              visited: false,
            });
          } else {
            existingData?.splice(existingData?.length, 0, {
              mkmID: mkmID,
              orderNumber: existingData?.length,
              visited: false,
            });
            requestBody = existingData?.map((item, i) => {
              return {
                mkmID: item?.place?.mkmID || item?.mkmID,
                orderNumber: i,
                visited: item?.visited,
              };
            });
          }
          try {
            setShowSpinner(true);
            let res = await updateRouteDetail(requestBody, {
              userName: userName,
              routeID: route?.id,
            });
            if (res && res?.status === 200) {
              toast.success("Point Added Successfully In Your Route!", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000,
              });
              setShowSpinner(false);
            }
          } catch (err) {
            toast.error(
              err?.response?.data?.message ||
                "Oops.. something went wrong, try again !!!",
              {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000,
              },
            );
            setShowSpinner(false);
          }
          setRoute("");
          setShowModal(false);
        } else {
          toast.warning(
            "Max of only 25 points can be added to a route, Kindly remove a point to add a new point.",
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            },
          );
          setShowSpinner(false);
        }
        setRoute("");
        setShowModal(false);
      } catch (error) {
        console.log(error);
        setShowSpinner(false);
      }
    }
    if (!route?.id) {
      toast.error("Please Select The Route.", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
      });
      setShowSpinner(false);
    }
  };

  const addToFavorite = async (id, fav) => {
    if (isUserLoggedIn) {
      let categoryName = Object.keys(id)[0];
      const willFavorite = await swal({
        title: "Are you sure?",
        text: "You want to add this route in Favorites?",
        icon: marked_pop,
        buttons: true,
      });
      if (willFavorite) {
        try {
          const obj = {
            userName: userName,
          };
          const data = {
            mkmId: categoryName === "mkmID" ? id?.mkmID : null,
            tzId: categoryName === "tzadikimID" ? id?.tzadikimID : null,
          };
          const response = await addUserFavorite(data, obj);
          setCheckForFavorite(fav);
          if (response && response?.status === 200) {
            swal(
              "Added!",
              "Your route has been added in Favorites!",
              "success",
            );
            categoryName === "tzadikimID"
              ? tzadikimPlaceDetail()
              : fetchPlaceDetails();
          }
        } catch (error) {
          toast.error(
            error?.response?.data?.message ||
              "Oops.. something went wrong, try again !!!",
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            },
          );
        }
      }
    } else {
      const notLoggedIn = await swal({
        title: "Please Continue to Log In",
        text: "You want to add this route in Favorites?",
        icon: marked_pop,
        buttons: ["Cancel", "Log In"],
      });
      if (notLoggedIn) {
        navigate("/sign-in");
      }
    }
  };

  const removeFromFavorite = async (id, fav) => {
    if (isUserLoggedIn) {
      let categoryName = Object.keys(id)[0];

      const willRemoveFavorite = await swal({
        title: "Are you sure?",
        text: "You want to remove this route from Favorites?",
        icon: marked_pop,
        buttons: true,
      });
      if (willRemoveFavorite) {
        try {
          const obj = {
            userName: userName,
          };
          const data = {
            mkmId: categoryName === "mkmID" ? id?.mkmID : null,
            tzId: categoryName === "tzadikimID" ? id?.tzadikimID : null,
          };
          const response = await removeUserFavorite(data, obj);
          setCheckForFavorite(fav);
          if (response && response?.status === 200) {
            swal(
              "Removed!",
              "Your route has been removed from Favorites!",
              "success",
            );
            categoryName === "tzadikimID"
              ? tzadikimPlaceDetail()
              : fetchPlaceDetails();
          }
        } catch (error) {
          toast.error(
            error?.response?.data?.message ||
              "Oops.. something went wrong, try again !!!",
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            },
          );
        }
      }
    } else {
      const notLoggedIn = await swal({
        title: "Please Continue to Log In",
        text: "You want to remove this route from Favorites?",
        icon: marked_pop,
        buttons: ["Cancel", "Log In"],
      });
      if (notLoggedIn) {
        navigate("/sign-in");
      }
    }
  };

  const onLoad = useCallback(
    async function callback(map) {
      if (!poi) setTempMap(map);
      if (poi) {
        const center = {
          lat: Number(detailPoi[0]),
          lng: Number(detailPoi[1]),
        };
        const bounds = new window.google.maps.LatLngBounds();
        bounds?.extend(center);
        map?.fitBounds(bounds);
        setMap(map);
      }
    },
    [poi],
  );

  useEffect(() => {
    if (poi) {
      onLoad(tempMap);
    }
  }, [poi, onLoad, tempMap]);

  const containerStyle = {
    width: "100%",
    height: "100%",
    borderRadius: "20px",
  };

  const handleImageModal = (imageId) => {
    setShowImageModal(true);
    setModalImageId(imageId);
  };

  // const handleScrollLeft = () => {
  //   if (imageContainerRef.current) {
  //     imageContainerRef.current.scrollBy({ left: -200, behavior: "smooth" });
  //   }
  // };
  // const handleScrollRight = () => {
  //   if (imageContainerRef.current) {
  //     imageContainerRef.current.scrollBy({ left: 200, behavior: "smooth" });
  //   }
  // };

  const tzadikimSections = [
    { key: "mchs", title: "בעל מחבר ספר(ים)" },
    { key: "tfilis", title: "תפילות וענינים מהצדיק" },
    { key: "toldes", title: "תולדות" },
  ];
  return (
    <div className="main_section cemetery_detail">
      <ContainerLayout>
        <SelectRouteModal
          route={route}
          setRoute={setRoute}
          showModal={showModal}
          toggle={toggle}
          createNewRoute={createNewRoute}
          selectRoute={selectRoute}
          showSpinner={showSpinner}
        />
        <CreateNewRouteModal
          showCreateRouteModal={showCreateRouteModal}
          setShowCreateRouteModal={setShowCreateRouteModal}
          showListModal={showListModal}
          setShowListModal={setShowListModal}
          routeName={routeName}
          setRouteName={setRouteName}
          pointName={pointName}
          setPointName={setPointName}
          pointId={mkmID}
        />
        <PointsListingModal
          showListModal={showListModal}
          setShowListModal={setShowListModal}
          setRouteName={setRouteName}
          routeName={routeName}
          pointName={pointName}
          setPointName={setPointName}
        />
        <ReportSuggestionModal
          showReportModal={showReportModal}
          setShowReportModal={setShowReportModal}
          showListModal={showListModal}
          setShowListModal={setShowListModal}
          setRouteName={setRouteName}
          routeName={routeName}
          pointName={pointName}
          mkmID={mkmID}
        />
        <ShareModal
          showShareModal={showShareModal}
          setShowShareModal={setShowShareModal}
          link={link}
          setLink={setLink}
        />
        <ViewImagesModal
          modal={showImageModal}
          setShowImageModal={setShowImageModal}
          imageIDs={modalImageId}
          setModalImageId={setModalImageId}
          imagesArr={place?.imageIDs}
        />
        {/* <SearchBar /> */}
        <div style={{ maxWidth: "1150px", marginInline: "auto" }}>
          <BreadcrumbSection
            categoryIcon={categoryIcon}
            categoryName={categoryName}
            categoryTitle={categoryTitle}
            from={from}
            location={location}
          />
          <div className="details_section">
            <div>
              <div className="details_box">
                {categoryName != "Tzadikim" ? (
                  <>
                    <Container>
                      <Row className="me-1"></Row>
                      <div className="detail_sections1">
                        <div
                          className="detail_section_1"
                          // style={{
                          //   height:
                          //     tzadikimTitle.length !== 0 ? "450px" : "600px",
                          // }}
                        >
                          <div
                            className="details_left_section"
                            ref={firstDivRef}
                          >
                            <div className="_map">
                              <Col xs="12">
                                <div
                                  className="map"
                                  style={{
                                    height:
                                      place?.imageIDs?.length > 0
                                        ? `${secondDivHeight - 190}px`
                                        : `${secondDivHeight}px`,
                                  }}
                                >
                                  {isLoaded && categoryName != "Tzadikim" ? (
                                    <div
                                      style={{
                                        height:
                                          place?.imageIDs?.length > 0
                                            ? "100%"
                                            : "100%",
                                      }}
                                    >
                                      <GoogleMap
                                        mapContainerStyle={containerStyle}
                                        onLoad={onLoad}
                                        options={options}
                                        zoom={12}
                                      >
                                        {markers?.map((item) => (
                                          <div key={item?.poi}>
                                            <Marker
                                              position={{
                                                lat: Number(
                                                  item?.poi?.split(",")[0],
                                                ),
                                                lng: Number(
                                                  item?.poi?.split(",")[1],
                                                ),
                                              }}
                                              onClick={() =>
                                                handleActiveMarker(item?.id)
                                              }
                                              onLoad={(marker) => {
                                                const customIcon = (opts) =>
                                                  Object.assign(
                                                    {
                                                      path: "M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z",
                                                      fillColor: "#34495e",
                                                      fillOpacity: 1,
                                                      strokeColor: "teal",
                                                      strokeWeight: 2,
                                                      scale: 1,
                                                    },
                                                    opts,
                                                  );
                                                item?.categoryId === 1
                                                  ? marker.setIcon(
                                                      customIcon({
                                                        fillColor: "#d2b48c",
                                                        strokeColor: "white",
                                                      }),
                                                    )
                                                  : item?.categoryId === 10
                                                    ? marker.setIcon(
                                                        customIcon({
                                                          fillColor: "teal",
                                                          strokeColor: "white",
                                                        }),
                                                      )
                                                    : item?.categoryId === 5
                                                      ? marker.setIcon(
                                                          customIcon({
                                                            fillColor:
                                                              "turquoise",
                                                            strokeColor:
                                                              "white",
                                                          }),
                                                        )
                                                      : item?.categoryId === 4
                                                        ? marker.setIcon(
                                                            customIcon({
                                                              fillColor: "gold",
                                                              strokeColor:
                                                                "white",
                                                            }),
                                                          )
                                                        : item?.categoryId === 2
                                                          ? marker.setIcon(
                                                              customIcon({
                                                                fillColor:
                                                                  "#000080",
                                                                strokeColor:
                                                                  "white",
                                                              }),
                                                            )
                                                          : item?.categoryId ===
                                                              7
                                                            ? marker.setIcon(
                                                                customIcon({
                                                                  fillColor:
                                                                    "#00ffff",
                                                                  strokeColor:
                                                                    "white",
                                                                }),
                                                              )
                                                            : item?.categoryId ===
                                                                9
                                                              ? marker.setIcon(
                                                                  customIcon({
                                                                    fillColor:
                                                                      "tomato",
                                                                    strokeColor:
                                                                      "white",
                                                                  }),
                                                                )
                                                              : item?.categoryId ===
                                                                  12
                                                                ? marker.setIcon(
                                                                    customIcon({
                                                                      fillColor:
                                                                        "wheat",
                                                                      strokeColor:
                                                                        "white",
                                                                    }),
                                                                  )
                                                                : marker.setIcon(
                                                                    customIcon({
                                                                      fillColor:
                                                                        "green",
                                                                    }),
                                                                  );
                                                return handleActiveMarker(
                                                  marker,
                                                  item,
                                                );
                                              }}
                                            >
                                              {activeMarker === item?.id ? (
                                                <InfoWindow
                                                  onCloseClick={() =>
                                                    setActiveMarker(null)
                                                  }
                                                >
                                                  <div className="info_window">
                                                    <Card body>
                                                      <div className="card_header">
                                                        {item?.userFavorite ===
                                                        true ? (
                                                          <Button
                                                            className="favourite_fill_icon"
                                                            onClick={() =>
                                                              removeFromFavorite(
                                                                item?.id,
                                                              )
                                                            }
                                                          >
                                                            <AiFillStar
                                                              size={20}
                                                            />
                                                          </Button>
                                                        ) : (
                                                          <Button
                                                            className="favourite_icon"
                                                            onClick={() =>
                                                              addToFavorite(
                                                                item?.id,
                                                              )
                                                            }
                                                          >
                                                            <AiOutlineStar
                                                              size={20}
                                                            />
                                                          </Button>
                                                        )}
                                                        <div className="right_section">
                                                          {from ===
                                                          "alongRoute" ? (
                                                            <Link
                                                              to={`/category-detail/${
                                                                item?.categoryId ===
                                                                12
                                                                  ? "?tzadikimId=" +
                                                                    item?.id
                                                                  : "?MkmId=" +
                                                                    item?.id
                                                              }&cor=${
                                                                item?.poi
                                                              }`}
                                                              state={{
                                                                from: "alongRoute",
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="card_link"
                                                            >
                                                              <CardTitle
                                                                tag="h5"
                                                                title={
                                                                  item?.mkmTitle
                                                                }
                                                              >
                                                                {item?.mkmTitle}
                                                              </CardTitle>
                                                            </Link>
                                                          ) : from ===
                                                            "addMorePointToRoute" ? (
                                                            <Link
                                                              to={`/category-detail/${
                                                                item?.categoryId ===
                                                                12
                                                                  ? "?tzadikimId=" +
                                                                    item?.id
                                                                  : "?MkmId=" +
                                                                    item?.id
                                                              }&cor=${
                                                                item?.poi
                                                              }`}
                                                              state={{
                                                                from: "addMorePointToRoute",
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="card_link"
                                                            >
                                                              <CardTitle
                                                                tag="h5"
                                                                title={
                                                                  item?.mkmTitle
                                                                }
                                                              >
                                                                {item?.mkmTitle}
                                                              </CardTitle>
                                                            </Link>
                                                          ) : from ===
                                                            "customAddress" ? (
                                                            <Link
                                                              to={`/category-detail/${
                                                                item?.categoryId ===
                                                                12
                                                                  ? "?tzadikimId=" +
                                                                    item?.id
                                                                  : "?MkmId=" +
                                                                    item?.id
                                                              }&cor=${
                                                                item?.poi
                                                              }`}
                                                              state={{
                                                                from: "customAddress",
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="card_link"
                                                            >
                                                              <CardTitle
                                                                tag="h5"
                                                                title={
                                                                  item?.mkmTitle
                                                                }
                                                              >
                                                                {item?.mkmTitle}
                                                              </CardTitle>
                                                            </Link>
                                                          ) : from ===
                                                            "routeDetail" ? (
                                                            <Link
                                                              to={`/category-detail/${
                                                                item?.categoryId ===
                                                                12
                                                                  ? "?tzadikimId=" +
                                                                    item?.id
                                                                  : "?MkmId=" +
                                                                    item?.id
                                                              }&cor=${
                                                                item?.poi
                                                              }`}
                                                              state={{
                                                                from: "routeDetail",
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="card_link"
                                                            >
                                                              <CardTitle
                                                                tag="h5"
                                                                title={
                                                                  item?.mkmTitle
                                                                }
                                                              >
                                                                {item?.mkmTitle}
                                                              </CardTitle>
                                                            </Link>
                                                          ) : from ===
                                                            "alongPreviousPoint" ? (
                                                            <Link
                                                              to={`/category-detail/${
                                                                item?.categoryId ===
                                                                12
                                                                  ? "?tzadikimId=" +
                                                                    item?.id
                                                                  : "?MkmId=" +
                                                                    item?.id
                                                              }&cor=${
                                                                item?.poi
                                                              }`}
                                                              state={{
                                                                from: "alongPreviousPoint",
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="card_link"
                                                            >
                                                              <CardTitle
                                                                tag="h5"
                                                                title={
                                                                  item?.mkmTitle
                                                                }
                                                              >
                                                                {item?.mkmTitle}
                                                              </CardTitle>
                                                            </Link>
                                                          ) : from ===
                                                            "exploreNearMe" ? (
                                                            <Link
                                                              to={`/category-detail/${
                                                                item?.categoryId ===
                                                                12
                                                                  ? "?tzadikimId=" +
                                                                    item?.id
                                                                  : "?MkmId=" +
                                                                    item?.id
                                                              }&cor=${
                                                                item?.poi
                                                              }`}
                                                              state={{
                                                                from: "exploreNearMe",
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="card_link"
                                                            >
                                                              <CardTitle
                                                                tag="h5"
                                                                title={
                                                                  item?.mkmTitle
                                                                }
                                                              >
                                                                {item?.mkmTitle}
                                                              </CardTitle>
                                                            </Link>
                                                          ) : from ===
                                                            "favourite" ? (
                                                            <Link
                                                              to={`/category-detail/${
                                                                item?.categoryId ===
                                                                12
                                                                  ? "?tzadikimId=" +
                                                                    item?.id
                                                                  : "?MkmId=" +
                                                                    item?.id
                                                              }&cor=${
                                                                item?.poi
                                                              }`}
                                                              state={{
                                                                from: "favourite",
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="card_link"
                                                            >
                                                              <CardTitle
                                                                tag="h5"
                                                                title={
                                                                  item?.mkmTitle
                                                                }
                                                              >
                                                                {item?.mkmTitle}
                                                              </CardTitle>
                                                            </Link>
                                                          ) : from ===
                                                            "routeDetailExploreNearBy" ? (
                                                            <Link
                                                              to={`/category-detail/${
                                                                item?.categoryId ===
                                                                12
                                                                  ? "?tzadikimId=" +
                                                                    item?.id
                                                                  : "?MkmId=" +
                                                                    item?.id
                                                              }&cor=${
                                                                item?.poi
                                                              }`}
                                                              state={{
                                                                from: "routeDetailExploreNearBy",
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="card_link"
                                                            >
                                                              <CardTitle
                                                                tag="h5"
                                                                title={
                                                                  item?.mkmTitle
                                                                }
                                                              >
                                                                {item?.mkmTitle}
                                                              </CardTitle>
                                                            </Link>
                                                          ) : from ===
                                                            "topPlaces" ? (
                                                            <Link
                                                              to={`/category-detail/${
                                                                item?.categoryId ===
                                                                12
                                                                  ? "?tzadikimId=" +
                                                                    item?.id
                                                                  : "?MkmId=" +
                                                                    item?.id
                                                              }&cor=${
                                                                item?.poi
                                                              }`}
                                                              state={{
                                                                from: "topPlaces",
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="card_link"
                                                            >
                                                              <CardTitle
                                                                tag="h5"
                                                                title={
                                                                  item?.mkmTitle
                                                                }
                                                              >
                                                                {item?.mkmTitle}
                                                              </CardTitle>
                                                            </Link>
                                                          ) : from ===
                                                            "searchEverywhere" ? (
                                                            <Link
                                                              to={`/category-detail/${
                                                                item?.categoryId ===
                                                                12
                                                                  ? "?tzadikimId=" +
                                                                    item?.id
                                                                  : "?MkmId=" +
                                                                    item?.id
                                                              }&cor=${
                                                                item?.poi
                                                              }`}
                                                              state={{
                                                                from: "searchEverywhere",
                                                                data: location
                                                                  ?.state?.data,
                                                                key: location
                                                                  ?.state?.key,
                                                              }}
                                                              className="card_link"
                                                            >
                                                              <CardTitle
                                                                tag="h5"
                                                                title={
                                                                  item?.mkmTitle
                                                                }
                                                              >
                                                                {item?.mkmTitle}
                                                              </CardTitle>
                                                            </Link>
                                                          ) : (
                                                            <Link
                                                              to={`/category-detail/${
                                                                item?.categoryId ===
                                                                12
                                                                  ? "?tzadikimId=" +
                                                                    item?.id
                                                                  : "?MkmId=" +
                                                                    item?.id
                                                              }&cor=${
                                                                item?.poi
                                                              }`}
                                                              state={{
                                                                categoryName:
                                                                  categoryName,
                                                                categoryTitle:
                                                                  categoryTitle,
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="card_link"
                                                            >
                                                              <CardTitle
                                                                tag="h5"
                                                                title={
                                                                  item?.mkmTitle
                                                                }
                                                              >
                                                                {item?.mkmTitle}
                                                              </CardTitle>
                                                            </Link>
                                                          )}
                                                          <Dropdown
                                                            className="moreInfo"
                                                            toggle={() => {
                                                              setMenuOpen(
                                                                !dropdownMenuOpen,
                                                              );
                                                            }}
                                                            isOpen={
                                                              dropdownMenuOpen
                                                            }
                                                          >
                                                            <DropdownToggle>
                                                              <BiDotsVerticalRounded
                                                                size={20}
                                                              />
                                                            </DropdownToggle>
                                                            <DropdownMenu>
                                                              <DropdownItem>
                                                                {from ===
                                                                "alongRoute" ? (
                                                                  <Link
                                                                    to={`/along-the-way-to-here/${item?.poi}`}
                                                                    state={{
                                                                      from: "alongRoute",
                                                                      data: location
                                                                        ?.state
                                                                        ?.data,
                                                                    }}
                                                                    className="breadcrumb_item1"
                                                                  >
                                                                    Along the
                                                                    way to here
                                                                  </Link>
                                                                ) : from ===
                                                                  "addMorePointToRoute" ? (
                                                                  <Link
                                                                    to={`/along-the-way-to-here/${item?.poi}`}
                                                                    state={{
                                                                      from: "addMorePointToRoute",
                                                                      data: location
                                                                        ?.state
                                                                        ?.data,
                                                                    }}
                                                                    className="breadcrumb_item1"
                                                                  >
                                                                    Along the
                                                                    way to here
                                                                  </Link>
                                                                ) : from ===
                                                                  "customAddress" ? (
                                                                  <Link
                                                                    to={`/along-the-way-to-here/${item?.poi}`}
                                                                    state={{
                                                                      from: "customAddress",
                                                                      data: location
                                                                        ?.state
                                                                        ?.data,
                                                                    }}
                                                                    className="breadcrumb_item1"
                                                                  >
                                                                    Along the
                                                                    way to here
                                                                  </Link>
                                                                ) : from ===
                                                                  "routeDetail" ? (
                                                                  <Link
                                                                    to={`/along-the-way-to-here/${item?.poi}`}
                                                                    state={{
                                                                      from: "routeDetail",
                                                                      data: location
                                                                        ?.state
                                                                        ?.data,
                                                                    }}
                                                                    className="breadcrumb_item1"
                                                                  >
                                                                    Along the
                                                                    way to here
                                                                  </Link>
                                                                ) : from ===
                                                                  "alongPreviousPoint" ? (
                                                                  <Link
                                                                    to={`/along-the-way-to-here/${item?.poi}`}
                                                                    state={{
                                                                      from: "alongPreviousPoint",
                                                                      data: location
                                                                        ?.state
                                                                        ?.data,
                                                                    }}
                                                                    className="breadcrumb_item1"
                                                                  >
                                                                    Along the
                                                                    way to here
                                                                  </Link>
                                                                ) : from ===
                                                                  "exploreNearMe" ? (
                                                                  <Link
                                                                    to={`/along-the-way-to-here/${item?.poi}`}
                                                                    state={{
                                                                      from: "exploreNearMe",
                                                                      data: location
                                                                        ?.state
                                                                        ?.data,
                                                                    }}
                                                                    className="breadcrumb_item1"
                                                                  >
                                                                    Along the
                                                                    way to here
                                                                  </Link>
                                                                ) : from ===
                                                                  "favourite" ? (
                                                                  <Link
                                                                    to={`/along-the-way-to-here/${item?.poi}`}
                                                                    state={{
                                                                      from: "favourite",
                                                                      data: location
                                                                        ?.state
                                                                        ?.data,
                                                                    }}
                                                                    className="breadcrumb_item1"
                                                                  >
                                                                    Along the
                                                                    way to here
                                                                  </Link>
                                                                ) : from ===
                                                                  "routeDetailExploreNearBy" ? (
                                                                  <Link
                                                                    to={`/along-the-way-to-here/${item?.poi}`}
                                                                    state={{
                                                                      from: "routeDetailExploreNearBy",
                                                                      data: location
                                                                        ?.state
                                                                        ?.data,
                                                                    }}
                                                                    className="breadcrumb_item1"
                                                                  >
                                                                    Along the
                                                                    way to here
                                                                  </Link>
                                                                ) : from ===
                                                                  "topPlaces" ? (
                                                                  <Link
                                                                    to={`/along-the-way-to-here/${item?.poi}`}
                                                                    state={{
                                                                      from: "topPlaces",
                                                                      data: location
                                                                        ?.state
                                                                        ?.data,
                                                                    }}
                                                                    className="breadcrumb_item1"
                                                                  >
                                                                    Along the
                                                                    way to here
                                                                  </Link>
                                                                ) : from ===
                                                                  "searchEverywhere" ? (
                                                                  <Link
                                                                    to={`/along-the-way-to-here/${item?.poi}`}
                                                                    state={{
                                                                      from: "searchEverywhere",
                                                                      data: location
                                                                        ?.state
                                                                        ?.data,
                                                                      key: location
                                                                        ?.state
                                                                        ?.key,
                                                                    }}
                                                                    className="breadcrumb_item1"
                                                                  >
                                                                    Along the
                                                                    way to here
                                                                  </Link>
                                                                ) : (
                                                                  <Link
                                                                    to={`/along-the-way-to-here/${item?.poi}`}
                                                                    state={{
                                                                      categoryName:
                                                                        categoryName,
                                                                      categoryTitle:
                                                                        categoryTitle,
                                                                      data: location
                                                                        ?.state
                                                                        ?.data,
                                                                    }}
                                                                    className="breadcrumb_item1"
                                                                  >
                                                                    Along the
                                                                    way to here
                                                                  </Link>
                                                                )}
                                                              </DropdownItem>
                                                              <DropdownItem
                                                                onClick={() =>
                                                                  reportSuggestion(
                                                                    item?.mkmTitle,
                                                                    item?.id,
                                                                  )
                                                                }
                                                              >
                                                                Report
                                                                suggestion
                                                              </DropdownItem>
                                                            </DropdownMenu>
                                                          </Dropdown>
                                                        </div>
                                                      </div>
                                                      <CardText className="grid_text_le">
                                                        {item?.cityY + " "}{" "}
                                                        &nbsp; {item?.stateY}
                                                      </CardText>
                                                      <div className="card_bottom">
                                                        <Button
                                                          onClick={() =>
                                                            share(
                                                              item?.id,
                                                              item?.poi,
                                                            )
                                                          }
                                                        >
                                                          <FiShare2 size={20} />
                                                        </Button>
                                                        <div className="right_section">
                                                          <CardText>
                                                            {item?.cityE +
                                                              " " +
                                                              item?.stateE}
                                                          </CardText>
                                                          <MdLocationOn
                                                            className="location_icon"
                                                            size={18}
                                                          />
                                                        </div>
                                                      </div>
                                                      <div className="card_footer">
                                                        {from ===
                                                        "alongRoute" ? (
                                                          <>
                                                            <Link
                                                              to={`/explore-near-by/${item?.poi}`}
                                                              onClick={
                                                                exploreNearByCloseInfo
                                                              }
                                                              state={{
                                                                from: "alongRoute",
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="btn explore"
                                                            >
                                                              <BiExitFullscreen className="explore_icon" />
                                                              Explore Near By
                                                            </Link>
                                                            <Link
                                                              to={`/category-detail/${
                                                                item?.categoryId ===
                                                                12
                                                                  ? "?tzadikimId=" +
                                                                    item?.id
                                                                  : "?MkmId=" +
                                                                    item?.id
                                                              }&cor=${
                                                                item?.poi
                                                              }`}
                                                              state={{
                                                                from: "alongRoute",
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="btn viewmore"
                                                            >
                                                              View More
                                                            </Link>
                                                          </>
                                                        ) : from ===
                                                          "addMorePointToRoute" ? (
                                                          <>
                                                            <Link
                                                              to={`/explore-near-by/${item?.poi}`}
                                                              onClick={
                                                                exploreNearByCloseInfo
                                                              }
                                                              state={{
                                                                from: "addMorePointToRoute",
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="btn explore"
                                                            >
                                                              <BiExitFullscreen className="explore_icon" />
                                                              Explore Near By
                                                            </Link>
                                                            <Link
                                                              to={`/category-detail/${
                                                                item?.categoryId ===
                                                                12
                                                                  ? "?tzadikimId=" +
                                                                    item?.id
                                                                  : "?MkmId=" +
                                                                    item?.id
                                                              }&cor=${
                                                                item?.poi
                                                              }`}
                                                              state={{
                                                                from: "addMorePointToRoute",
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="btn viewmore"
                                                            >
                                                              View More
                                                            </Link>
                                                          </>
                                                        ) : from ===
                                                          "customAddress" ? (
                                                          <>
                                                            <Link
                                                              to={`/explore-near-by/${item?.poi}`}
                                                              onClick={
                                                                exploreNearByCloseInfo
                                                              }
                                                              state={{
                                                                from: "customAddress",
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="btn explore"
                                                            >
                                                              <BiExitFullscreen className="explore_icon" />
                                                              Explore Near By
                                                            </Link>
                                                            <Link
                                                              to={`/category-detail/${
                                                                item?.categoryId ===
                                                                12
                                                                  ? "?tzadikimId=" +
                                                                    item?.id
                                                                  : "?MkmId=" +
                                                                    item?.id
                                                              }&cor=${
                                                                item?.poi
                                                              }`}
                                                              state={{
                                                                from: "customAddress",
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="btn viewmore"
                                                            >
                                                              View More
                                                            </Link>
                                                          </>
                                                        ) : from ===
                                                          "routeDetail" ? (
                                                          <>
                                                            <Link
                                                              to={`/explore-near-by/${item?.poi}`}
                                                              onClick={
                                                                exploreNearByCloseInfo
                                                              }
                                                              state={{
                                                                from: "routeDetail",
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="btn explore"
                                                            >
                                                              <BiExitFullscreen className="explore_icon" />
                                                              Explore Near By
                                                            </Link>
                                                            <Link
                                                              to={`/category-detail/${
                                                                item?.categoryId ===
                                                                12
                                                                  ? "?tzadikimId=" +
                                                                    item?.id
                                                                  : "?MkmId=" +
                                                                    item?.id
                                                              }&cor=${
                                                                item?.poi
                                                              }`}
                                                              state={{
                                                                from: "routeDetail",
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="btn viewmore"
                                                            >
                                                              View More
                                                            </Link>
                                                          </>
                                                        ) : from ===
                                                          "alongPreviousPoint" ? (
                                                          <>
                                                            <Link
                                                              to={`/explore-near-by/${item?.poi}`}
                                                              onClick={
                                                                exploreNearByCloseInfo
                                                              }
                                                              state={{
                                                                from: "alongPreviousPoint",
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="btn explore"
                                                            >
                                                              <BiExitFullscreen className="explore_icon" />
                                                              Explore Near By
                                                            </Link>
                                                            <Link
                                                              to={`/category-detail/${
                                                                item?.categoryId ===
                                                                12
                                                                  ? "?tzadikimId=" +
                                                                    item?.id
                                                                  : "?MkmId=" +
                                                                    item?.id
                                                              }&cor=${
                                                                item?.poi
                                                              }`}
                                                              state={{
                                                                from: "alongPreviousPoint",
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="btn viewmore"
                                                            >
                                                              View More
                                                            </Link>
                                                          </>
                                                        ) : from ===
                                                          "exploreNearMe" ? (
                                                          <>
                                                            <Link
                                                              to={`/explore-near-by/${item?.poi}`}
                                                              onClick={
                                                                exploreNearByCloseInfo
                                                              }
                                                              state={{
                                                                from: "exploreNearMe",
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="btn explore"
                                                            >
                                                              <BiExitFullscreen className="explore_icon" />
                                                              Explore Near By
                                                            </Link>
                                                            <Link
                                                              to={`/category-detail/${
                                                                item?.categoryId ===
                                                                12
                                                                  ? "?tzadikimId=" +
                                                                    item?.id
                                                                  : "?MkmId=" +
                                                                    item?.id
                                                              }&cor=${
                                                                item?.poi
                                                              }`}
                                                              state={{
                                                                from: "exploreNearMe",
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="btn viewmore"
                                                            >
                                                              View More
                                                            </Link>
                                                          </>
                                                        ) : from ===
                                                          "favourite" ? (
                                                          <>
                                                            <Link
                                                              to={`/explore-near-by/${item?.poi}`}
                                                              onClick={
                                                                exploreNearByCloseInfo
                                                              }
                                                              state={{
                                                                from: "favourite",
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="btn explore"
                                                            >
                                                              <BiExitFullscreen className="explore_icon" />
                                                              Explore Near By
                                                            </Link>
                                                            <Link
                                                              to={`/category-detail/${
                                                                item?.categoryId ===
                                                                12
                                                                  ? "?tzadikimId=" +
                                                                    item?.id
                                                                  : "?MkmId=" +
                                                                    item?.id
                                                              }&cor=${
                                                                item?.poi
                                                              }`}
                                                              state={{
                                                                from: "favourite",
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="btn viewmore"
                                                            >
                                                              View More
                                                            </Link>
                                                          </>
                                                        ) : from ===
                                                          "routeDetailExploreNearBy" ? (
                                                          <>
                                                            <Link
                                                              to={`/explore-near-by/${item?.poi}`}
                                                              onClick={
                                                                exploreNearByCloseInfo
                                                              }
                                                              state={{
                                                                from: "routeDetailExploreNearBy",
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="btn explore"
                                                            >
                                                              <BiExitFullscreen className="explore_icon" />
                                                              Explore Near By
                                                            </Link>
                                                            <Link
                                                              to={`/category-detail/${
                                                                item?.categoryId ===
                                                                12
                                                                  ? "?tzadikimId=" +
                                                                    item?.id
                                                                  : "?MkmId=" +
                                                                    item?.id
                                                              }&cor=${
                                                                item?.poi
                                                              }`}
                                                              state={{
                                                                from: "routeDetailExploreNearBy",
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="btn viewmore"
                                                            >
                                                              View More
                                                            </Link>
                                                          </>
                                                        ) : from ===
                                                          "topPlaces" ? (
                                                          <>
                                                            <Link
                                                              to={`/explore-near-by/${item?.poi}`}
                                                              onClick={
                                                                exploreNearByCloseInfo
                                                              }
                                                              state={{
                                                                from: "topPlaces",
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="btn explore"
                                                            >
                                                              <BiExitFullscreen className="explore_icon" />
                                                              Explore Near By
                                                            </Link>
                                                            <Link
                                                              to={`/category-detail/${
                                                                item?.categoryId ===
                                                                12
                                                                  ? "?tzadikimId=" +
                                                                    item?.id
                                                                  : "?MkmId=" +
                                                                    item?.id
                                                              }&cor=${
                                                                item?.poi
                                                              }`}
                                                              state={{
                                                                from: "topPlaces",
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="btn viewmore"
                                                            >
                                                              View More
                                                            </Link>
                                                          </>
                                                        ) : from ===
                                                          "searchEverywhere" ? (
                                                          <>
                                                            <Link
                                                              to={`/explore-near-by/${item?.poi}`}
                                                              onClick={
                                                                exploreNearByCloseInfo
                                                              }
                                                              state={{
                                                                from: "searchEverywhere",
                                                                data: location
                                                                  ?.state?.data,
                                                                key: location
                                                                  ?.state?.key,
                                                              }}
                                                              className="btn explore"
                                                            >
                                                              <BiExitFullscreen className="explore_icon" />
                                                              Explore Near By
                                                            </Link>
                                                            <Link
                                                              to={`/category-detail/${
                                                                item?.categoryId ===
                                                                12
                                                                  ? "?tzadikimId=" +
                                                                    item?.id
                                                                  : "?MkmId=" +
                                                                    item?.id
                                                              }&cor=${
                                                                item?.poi
                                                              }`}
                                                              state={{
                                                                from: "searchEverywhere",
                                                                data: location
                                                                  ?.state?.data,
                                                                key: location
                                                                  ?.state?.key,
                                                              }}
                                                              className="btn viewmore"
                                                            >
                                                              View More
                                                            </Link>
                                                          </>
                                                        ) : (
                                                          <>
                                                            <Link
                                                              to={`/explore-near-by/${item?.poi}`}
                                                              onClick={
                                                                exploreNearByCloseInfo
                                                              }
                                                              state={{
                                                                categoryName:
                                                                  categoryName,
                                                                categoryTitle:
                                                                  categoryTitle,
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="btn explore"
                                                            >
                                                              <BiExitFullscreen className="explore_icon" />
                                                              Explore Near By
                                                            </Link>
                                                            <Link
                                                              to={`/category-detail/${
                                                                item?.categoryId ===
                                                                12
                                                                  ? "?tzadikimId=" +
                                                                    item?.id
                                                                  : "?MkmId=" +
                                                                    item?.id
                                                              }&cor=${
                                                                item?.poi
                                                              }`}
                                                              state={{
                                                                categoryName:
                                                                  categoryName,
                                                                categoryTitle:
                                                                  categoryTitle,
                                                                data: location
                                                                  ?.state?.data,
                                                              }}
                                                              className="btn viewmore"
                                                            >
                                                              View More
                                                            </Link>
                                                          </>
                                                        )}
                                                        <Button
                                                          className="btn addroute"
                                                          onClick={() =>
                                                            addToRoute(
                                                              item?.id,
                                                              item,
                                                            )
                                                          }
                                                        >
                                                          <FiBriefcase className="addroute_icon" />
                                                          <span>
                                                            Add to Route
                                                          </span>
                                                        </Button>
                                                      </div>
                                                    </Card>
                                                  </div>
                                                </InfoWindow>
                                              ) : null}
                                            </Marker>
                                            <Marker
                                              position={{
                                                lat: Number(nearBy?.[0]),
                                                lng: Number(nearBy?.[1]),
                                              }}
                                              icon={{
                                                url:
                                                  item?.categoryId === 1
                                                    ? "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
                                                    : item?.categoryId === 10
                                                      ? "http://maps.google.com/mapfiles/ms/icons/blue-dot.png"
                                                      : item?.categoryId === 5
                                                        ? "http://maps.google.com/mapfiles/ms/icons/purple-dot.png"
                                                        : item?.categoryId === 4
                                                          ? require("../../../../assets/darkpurple.png")
                                                          : item?.categoryId ===
                                                              2
                                                            ? "http://maps.google.com/mapfiles/ms/icons/ltblue-dot.png"
                                                            : item?.categoryId ===
                                                                7
                                                              ? "http://maps.google.com/mapfiles/ms/icons/pink-dot.png"
                                                              : item?.categoryId ===
                                                                  9
                                                                ? require("../../../../assets/gray.png")
                                                                : item?.categoryId ===
                                                                    12
                                                                  ? require("../../../../assets/darkblue.png")
                                                                  : require("../../../../assets/lightpink.png"),
                                              }}
                                            />
                                          </div>
                                        ))}
                                      </GoogleMap>
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                                <div className="map_footer"></div>
                              </Col>
                            </div>

                            <div
                              className="image-carousel"
                              style={{
                                display:
                                  place?.imageIDs?.length === 0
                                    ? "none"
                                    : "block",
                              }}
                            >
                              {place?.imageIDs?.length > 0 &&
                                categoryName !== "Tzadikim" && (
                                  <div
                                    className="nt-carousel-container"
                                    style={{
                                      width:
                                        place?.imageIDs?.length == 2
                                          ? "350px"
                                          : "",
                                    }}
                                  >
                                    <AliceCarousel
                                      mouseTracking
                                      items={place.imageIDs.map((imageId) => (
                                        <img
                                          key={imageId}
                                          src={`${API_URL}/api/mkm/getimage/${imageId}`}
                                          alt={`mkmImageId-${imageId}`}
                                          className="images"
                                          onClick={() =>
                                            handleImageModal(imageId)
                                          }
                                        />
                                      ))}
                                      ref={carouselRef}
                                      disableDotsControls={true}
                                      disableButtonsControls={true}
                                      autoPlay={false}
                                      responsive={responsive}
                                    />

                                    {/* Custom Buttons */}
                                    {place?.imageIDs?.length > 3 ? (
                                      <>
                                        <button
                                          className="carousel-btn prev-btn"
                                          onClick={() =>
                                            carouselRef.current?.slidePrev()
                                          }
                                        >
                                          <FaArrowLeft />
                                        </button>
                                        <button
                                          className="carousel-btn next-btn"
                                          onClick={() =>
                                            carouselRef.current?.slideNext()
                                          }
                                        >
                                          <FaArrowRight />
                                        </button>
                                      </>
                                    ) : (
                                      <div></div>
                                    )}
                                  </div>
                                )}
                            </div>
                          </div>
                          <div
                            className="details_right_section"
                            ref={secondDivRef}
                          >
                            <div className="top_heading_section">
                              <div className="top_heading">
                                <div className="top_heading_buttons">
                                  <button
                                    className="btn_navigate"
                                    onClick={NavigateClick}
                                  >
                                    <IoNavigateSharp className="btn_navigate_icon" />{" "}
                                    Navigate
                                  </button>
                                  <button
                                    className="btn_addRoute"
                                    onClick={() =>
                                      addToRoute(place?.mkmID, place)
                                    }
                                  >
                                    <BiPlus size={"18px"} /> Add to Route
                                  </button>
                                </div>
                                <div className="top_heading_details">
                                  <div className="top_heading_title">
                                    <h4>{place?.title}</h4>

                                    <ul>
                                      <li>
                                        {place?.cityY ? place?.cityY : null}
                                        {place?.stateY
                                          ? " " + place?.stateY
                                          : null}
                                      </li>
                                    </ul>
                                  </div>
                                  <div className="location">
                                    <p>
                                      {place?.cityE}, {place?.stateE}
                                    </p>
                                    <TiLocation
                                      style={{ color: "#618FFB" }}
                                      size={"22px"}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            {tzadikimTitle.length !== 0 && (
                              <div className="title_section">
                                <div className="title_info">
                                  <div className="title_heading">
                                    <h4>Tzadikim / צדיקים</h4>
                                  </div>
                                  <div className="title_btn">
                                    {tzadikimTitle?.map((item, index) => {
                                      return (
                                        <button
                                          onClick={() => {
                                            NavigateToTzadikim(
                                              item?.tzadikimID,
                                              place?.poi,
                                            );
                                          }}
                                          className="btn viewmore tza"
                                        >
                                          {item?.tzadikimName}
                                        </button>
                                      );
                                    })}
                                  </div>
                                </div>
                              </div>
                            )}

                            <div className="footer_section">
                              <div className="footer_left_section">
                                <div className="add_info">
                                  <h4>Additional Info</h4>
                                  <p>
                                    {place?.info
                                      ? place?.info
                                          ?.split("\n")
                                          .map((item, index) => {
                                            return (
                                              <span key={index}>{item}</span>
                                            );
                                          })
                                      : "N/A"}
                                  </p>
                                </div>
                              </div>
                              <div className="footer_right_section">
                                {categoryName == "Tzadikim" ? null : (
                                  <div className="contact_info">
                                    <h4>שומר (Caretaker)</h4>
                                    <p>
                                      {place?.sInfo ? (
                                        place.sInfo
                                          .split("\n")
                                          .map((item, index) =>
                                            item.includes("+") ? (
                                              <div
                                                className="contact_number"
                                                key={index}
                                              >
                                                <MdCall
                                                  style={{ color: "#494949" }}
                                                  size="20px"
                                                />
                                                {item}
                                              </div>
                                            ) : (
                                              <div
                                                className="other_info"
                                                key={index}
                                              >
                                                {item}
                                              </div>
                                            ),
                                          )
                                      ) : (
                                        <p>N/A</p>
                                      )}
                                    </p>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <Row xs="2">
                        {categoryName === "Tzadikim" ? (
                          <Col lg="12" md="12" xs="12">
                            <div className="tzk_detail">
                              <h3>בעל מחבר ספר(ים)</h3>

                              <p>
                                {place?.mchs
                                  ? place?.mchs
                                      ?.split("\n")
                                      .map((item, index) => {
                                        return (
                                          <span key={index}>
                                            {item}
                                            <br />
                                          </span>
                                        );
                                      })
                                  : "N/A"}
                              </p>
                            </div>
                          </Col>
                        ) : null}

                        {categoryName === "Tzadikim" ? (
                          <Col lg="12" md="12" xs="12">
                            <div className="tzk_detail">
                              <h3>תולדות</h3>
                              <p className="tzk_detail_p">
                                {place?.toldes
                                  ? // back to line if you fine /n
                                    place?.toldes
                                      ?.split("\n")
                                      .map((item, index) => {
                                        return (
                                          <span key={index}>
                                            {item}
                                            <br />
                                          </span>
                                        );
                                      })
                                  : "N/A"}
                              </p>
                            </div>
                          </Col>
                        ) : null}
                      </Row>
                    </Container>
                    {/* {place?.imageIDs?.length > 0 && <div className="bg-white p-2 my-2 rounded-5">
                <h4 className="mx-3 my-2">Images</h4>
                <div className="flex flex-wrap p-2">
                  { place?.imageIDs.map((imageId)=> <img src={`${API_URL}/api/mkm/getimage/${imageId}`} alt={`mkmImageId-${imageId}`} className="mkmImages mx-1" /> ) }
                </div>
              </div>} */}
                  </>
                ) : (
                  <div>
                    <div className="details_box1">
                      <div className="left-side">
                        <div className="top-heading">
                          <div className="location ">
                            <TiLocation
                              style={{ color: "#618FFB" }}
                              size={"22px"}
                            />
                            {place?.cityE}, {place?.stateE}
                          </div>
                          <div
                            className="share"
                            onClick={() =>
                              share(
                                place?.tzadikimID
                                  ? place?.tzadikimID
                                  : place?.mkmID,
                                place?.poi,
                              )
                            }
                          >
                            <FaShareAlt size={"15px"} />
                            Share
                          </div>
                        </div>

                        <div className="images carousel-container">
                          {categoryName === "Tzadikim" &&
                          place?.imageIDs?.length > 0 ? (
                            <div className="carousel-wrapper">
                              <AliceCarousel
                                ref={imageContainerRef}
                                mouseTracking
                                responsive={{
                                  0: { items: 1 },
                                  568: { items: 1 },
                                  1024: { items: 1 },
                                }}
                                items={place.imageIDs?.map((imageId) => (
                                  <div
                                    className="item"
                                    data-value={imageId}
                                    key={imageId}
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <img
                                      src={`${API_URL}/api/mkm/getimage/${imageId}`}
                                      alt={`${imageId}`}
                                      className="tzadikimImages"
                                      onClick={() => handleImageModal(imageId)}
                                    />
                                  </div>
                                ))}
                                controlsStrategy="alternate"
                                disableDotsControls={
                                  place?.imageIDs?.length === 1 ? true : false
                                }
                                disableButtonsControls={true} // hide built-in buttons
                                animationDuration={1000}
                                // ref={(el) => (imageContainerRef = el)}
                              />
                              {/* Custom buttons */}
                              {categoryName === "Tzadikim" &&
                              place?.imageIDs?.length !== 1 ? (
                                <div>
                                  <button
                                    className="carousel-btn prev-btn"
                                    onClick={handlePrev}
                                    disabled={currentIndex === 0}
                                  >
                                    {" "}
                                    <FaArrowLeft color="#FFFFFF" />
                                  </button>
                                  <button
                                    className="carousel-btn next-btn"
                                    onClick={handleNext}
                                    disabled={
                                      currentIndex === images.length - 1
                                    }
                                  >
                                    <FaArrowRight color="#FFFFFF" />
                                  </button>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          ) : (
                            <img
                              src={card_image}
                              alt="placeholder"
                              style={{
                                cursor: "pointer",
                                maxHeight: "403px",
                                width: "513px",
                                height: "auto",
                                objectFit: "cover",
                                borderRadius: "10px",
                              }}
                            />
                          )}
                        </div>
                      </div>
                      <div className="right_side">
                        <div className="heading_right_side">
                          <div className="heading_info">
                            <h4>{place?.title}</h4>
                            <ul>
                              <li>
                                {place?.nfInfo ? place?.nfInfo : place?.stateY}
                                {place?.nlInfo ? " - " + place?.nlInfo : null}
                              </li>
                            </ul>
                          </div>
                          <div className="detai_button">
                            <div className="buttons">
                              <button
                                className="btns btn-navigate"
                                onClick={NavigateClick}
                              >
                                <IoNavigateSharp
                                  className="navigate_icon"
                                  size={"18px"}
                                />
                                Navigate
                              </button>
                              <button
                                onClick={() => {
                                  navigateToCemetry(place?.mkmID);
                                }}
                                className="btns btn-location"
                              >
                                <TiLocation className="location-icon" />
                                <span
                                  style={{
                                    fontSize: "16px",
                                    fontFamily: "Lato",
                                    fontWeight: 600,
                                    marginBottom: "3px",
                                  }}
                                >
                                  מקום מנוחותו
                                </span>
                              </button>
                              <button
                                className="btns btn-addRoute"
                                onClick={() => addToRoute(place?.mkmID, place)}
                              >
                                <BiPlus size={"21px"} className="plus_icon" />
                                Add to Route
                              </button>
                            </div>
                          </div>
                        </div>
                        <div>
                          {categoryName === "Tzadikim" ? (
                            // <Accordion level={4} dir="rtl">
                            //   {tzadikimSections.map(({ key, title }, idx) => (
                            //     <Accordion.Section
                            //       key={key}
                            //       isBare={idx === 0 ? false : undefined}
                            //     >
                            //       <Accordion.Header>
                            //         <Accordion.Label>
                            //           <h3 className="accordion-title">{title}</h3>
                            //         </Accordion.Label>
                            //       </Accordion.Header>
                            //       <Accordion.Panel className="accordion-panel">
                            //         <div className="panel-box">
                            //           <section className="panel-box__inner">
                            //             {place?.[key] || "N/A"}
                            //           </section>
                            //         </div>
                            //       </Accordion.Panel>
                            //     </Accordion.Section>
                            //   ))}
                            // </Accordion>
                            <div className="custom_accordion">
                              {tzadikimSections.map(({ key, title }, idx) => {
                                const isOpen = openIndex === idx;

                                return (
                                  <div key={key}>
                                    <div
                                      className="accordion_heading"
                                      onClick={() => toggleSection(idx)}
                                    >
                                      <div className="icon">
                                        {isOpen ? (
                                          <FaChevronUp />
                                        ) : (
                                          <FaChevronDown />
                                        )}
                                      </div>
                                      <h3>{title}</h3>
                                    </div>
                                    <div
                                      className={`accordion_inner_content`}
                                      style={{
                                        maxHeight: isOpen ? "" : "0",
                                        paddingBlock: isOpen ? "20px" : "0",
                                        opacity: isOpen ? "1" : "0",
                                      }}
                                    >
                                      <section>{place?.[key] || "N/A"}</section>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    {/* <Row> */}
                    {/* <Col lg={6} sm={12}>
                      {categoryName === "Tzadikim" ? (
                        <Col lg="11" md="12" xs="12" className="m-auto">
                          <div className="tzk_detail">
                            <h3>בעל מחבר ספר(ים) </h3>
                            <p className="px-3 justify bg-light">
                              {place?.mchs ? place?.mchs : "N/A"}
                            </p>{" "}
                          </div>
                        </Col>
                      ) : null}

                      {categoryName === "Tzadikim" ? (
                        <Col lg="11" md="12" xs="12" className="m-auto">
                          <div className="tzk_detail">
                            <h3>תפילות וענינים מהצדיק </h3>
                            <p className="px-3 justify bg-light">
                              {place?.tfilis ? place?.tfilis : "N/A"}
                            </p>
                          </div>
                        </Col>
                      ) : null}

                      {categoryName === "Tzadikim" ? (
                        <Col lg="11" md="12" xs="12" className="m-auto">
                          <div className="tzk_detail">
                            <h3>תולדות </h3>
                            <p className="px-3 justify bg-light">
                              {place?.toldes ? place?.toldes : "N/A"}
                            </p>
                          </div>
                        </Col>
                      ) : null}
                    </Col> */}
                    {/* <Col lg={6} sm={12}>
                      <Col
                        lg="11"
                        md="12"
                        xs="12"
                        className="detail_sections m-auto"
                      >
                        <div className="detail_section px-3">
                          <div className="details_left">
                            <h4 className="fw-bolder">{place?.title}</h4>
                            <ul>
                              <li className="fw-bold">
                                {place?.nfInfo ? place?.nfInfo : place?.stateY}{" "}
                                {place?.nlInfo ? " - " + place?.nlInfo : null}
                              </li>
                            </ul>
                            <p className="location fw-bold">
                              {place?.streetNumber} {place?.streetName}
                            </p>
                            <p className="location fw-bold">
                              {place?.cityE}, {place?.stateE}
                            </p>
                            <p>
                                                    {place?.poi ? place?.poi : poi}
                                                </p>
                            <div className="contact">
                              <IoCallOutline size={25} className="contact_icon" />
                              <Label className="contact_number">N/A</Label>
                            </div>
                          </div>
                          <div className="detai_button">
                            <div className="buttons">
                              <Button
                                onClick={() => {
                                  navigateToCemetry(place?.mkmID);
                                }}
                                className="btn primary"
                              >
                                <IoLocation />
                                מקום מנוחותו
                              </Button>
                              <Button onClick={NavigateClick}>
                                <BiExitFullscreen />
                                Navigate
                              </Button>
                              <Button
                                onClick={() => addToRoute(place?.mkmID, place)}
                              >
                                <FiBriefcase />
                                Add to Route
                              </Button>
                            </div>
                          </div>
                        </div>
                      </Col>
                      {categoryName === "Tzadikim" &&
                        place?.imageIDs?.length > 0 && (
                          <div className="detail_sections m-auto mt-5">
                            <div className="bg-white w-100">
                              <AliceCarousel
                                mouseTracking
                                responsive={responsive}
                                controlsStrategy="alternate"
                                disableDotsControls={true}
                                autoPlay={false}
                                items={place.imageIDs.map((imageId) => (
                                  <div
                                    className="item"
                                    data-value={imageId}
                                    key={imageId}
                                  >
                                    <img
                                      src={`${API_URL}/api/mkm/getimage/${imageId}`}
                                      alt={`image-${imageId}`}
                                      className="tzadikimImages mx-1 rounded-3"
                                      onClick={() => handleImageModal(imageId)}
                                      style={{
                                        position: "relative",
                                        cursor: "pointer",
                                        maxHeight: "200px",
                                        objectFit: "cover",
                                      }}
                                    />
                                  </div>
                                ))}
                              />
                            </div>
                          </div>
                        )}
                    </Col> */}
                    {/* </Row> */}

                    {/* commented code below */}
                    {/* <Row xs="2"> */}
                    {/* <Col lg="12" md="12" xs="12" className="detail_sections"> */}
                    {/* <div className="row"> */}
                    {/* <div className="col-6">
                        {categoryName === "Tzadikim" && place?.imageIDs?.length > 0 && <div className="bg-white w-100">
                          <h4 className="mx-3 mb-2">Images</h4>
                          <div className="flex flex-wrap p-2">
                            { place?.imageIDs.map((imageId)=> <img src={`${API_URL}/api/mkm/getimage/${imageId}`} alt={`mkmImageId-${imageId}`} className="tzadikimImages mx-1 rounded-3" onClick={()=>handleImageModal(imageId)} /> ) }
                          </div>
                        </div>}
                      </div> */}
                    {/* <div className="detail_section col-6"> */}
                    {/* <div className="details_left">
                          <h4>{place?.title}</h4>
                          <ul>
                            <li>
                              {place?.nfInfo ? place?.nfInfo : place?.stateY}
                              {place?.nlInfo ? " - " + place?.nlInfo : null}
                            </li>
                          </ul>
                          <p className="location">
                            {place?.streetNumber} {place?.streetName}
                          </p>
                          <p className="location">
                            {place?.cityE}, {place?.stateE}
                          </p> */}
                    {/* <p>
                                                  {place?.poi ? place?.poi : poi}
                                              </p> */}
                    {/* <div className="contact">
                            <IoCallOutline size={25} className="contact_icon" />
                            <Label className="contact_number">N/A</Label>
                          </div>
                        </div> */}
                    {/* <div className="detai_button">
                          <div className="buttons">
                            <Button onClick={NavigateClick}>
                              <BiExitFullscreen />
                              Navigate
                            </Button>
                            <Button onClick={() => addToRoute(place?.mkmID,place)}>
                              <FiBriefcase />
                              Add to Route
                            </Button>
                          </div>
                        </div>
                      </div> */}
                    {/* </div> */}
                    {/* {categoryName === "Tzadikim" ? null : (
                      <div className="info_section">
                        <div className="shomer">
                          <h4>Shomer</h4>
                          <p>{place?.sInfo ? place?.sInfo : "N/A"}</p>
                        </div>
                        <div className="infoTza">
                          <div className="info">
                            <h4>Info</h4>
                            <p>{place?.info ? place?.info : "N/A"}</p>
                          </div>
                          <div className="info">
                            <h4>Tzadikim / צדיקים</h4>
                            {tzadikimTitle?.length > 0
                              ? tzadikimTitle?.map((item, index) => {
                                  // let tzadikimID = item?.id
                                  // return <Link to={`/category-detail/${tzadikimID}/${place.poi}`} state={{ from: 'favourite', categoryName: tzadikimID && "Tzadikim", categoryTitle: tzadikimID && "צדיקים" }}
                                  //  className="btn viewmore">
                                  // {item?.title}
                                  // </Link>

                                  return (
                                    <a
                                      onClick={() => {
                                        NavigateToTzadikim(
                                          item?.id,
                                          place?.poi
                                        );
                                      }}
                                      className="btn viewmore tza"
                                    >
                                      {item?.title}
                                    </a>
                                  );
                                })
                              : "N/A"}
                            <p></p>
                          </div>
                        </div>
                      </div>
                    )} */}
                    {/* </Col> */}

                    {/* {categoryName === "Tzadikim" ? (
                    <Col lg="12" md="12" xs="12">
                      <div className="tzk_detail">
                        <h3>מקום מנוחתו</h3> */}

                    {/* Link to the cemetry */}
                    {/* <Button
                          onClick={() => {
                            navigateToCemetry(place?.mkmID, poi);
                          }}
                          className="btn primary"
                        >
                          View
                        </Button> */}
                    {/* <p>{place?.nlInfo ? place?.nlInfo : 'N/A'}</p> */}
                    {/* </div>
                    </Col>
                  ) : null} */}
                    {/* {categoryName === "Tzadikim" && place?.imageIDs?.length > 0 && <div className="bg-white p-2 my-2 rounded-5 w-100">
                    <h4 className="mx-3 my-2">Images</h4>
                    <div className="flex flex-wrap p-2">
                      { place?.imageIDs.map((imageId)=> <img src={`${API_URL}/api/mkm/getimage/${imageId}`} alt={`mkmImageId-${imageId}`} className="tzadikimImages mx-1 rounded-3" onClick={()=>handleImageModal(imageId)} /> ) }
                    </div>
                  </div>} */}
                    {/* 
                  {categoryName === "Tzadikim" ? (
                    <Col lg="12" md="12" xs="12">
                      <div className="tzk_detail">
                        <h3>תפילות וענינים מהצדיק</h3>
                        <p>{place?.tfilis ? place?.tfilis : "N/A"}</p>
                      </div>
                    </Col>
                  ) : null} */}
                    {/* </Row> */}
                    {/* <Row xs="2">
                  {categoryName === "Tzadikim" ? (
                    <Col lg="12" md="12" xs="12">
                      <div className="tzk_detail">
                        <h3>בעל מחבר ספר(ים)</h3>
                        <p>{place?.mchs ? place?.mchs : "N/A"}</p>{" "}
                      </div>
                    </Col>
                  ) : null}

                  {categoryName === "Tzadikim" ? (
                    <Col lg="12" md="12" xs="12">
                      <div className="tzk_detail">
                        <h3>תולדות</h3>
                        <p>{place?.toldes ? place?.toldes : "N/A"}</p>
                      </div>
                    </Col>
                  ) : null}
                </Row> */}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </ContainerLayout>
    </div>
  );
}

export default Detail;
